import libphonenumber from 'google-libphonenumber';
export const validateEmail = str => {
    const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return reg.test(String(str).toLowerCase());
};
const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
export const validatePhone = (phone, countryCode = undefined) => {
    try {
        const phoneNumber = phoneUtil.parse(phone, countryCode);
        return phoneUtil.isValidNumber(phoneNumber);
    }
    catch (error) {
        return false;
    }
};
export const populateEmail = str => {
    if (validateEmail(str))
        return true;
    else if (str.includes('@'))
        return true;
    return false;
};
export const populatePhone = str => {
    const reg = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
    if (validatePhone(str))
        return true;
    else
        return reg.test(String(str).toLowerCase());
};
export const formatPhoneNumber = (phone, countryCode) => {
    try {
        const e164 = phoneUtil.format(phoneUtil.parse(phone, countryCode), libphonenumber.PhoneNumberFormat.E164);
        return e164;
    }
    catch (err) {
        return phone;
    }
};
export function validateUrl(link) {
    return !!String(link)
        .toLowerCase()
        .match(/^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[-a-zA-Z0-9@:%_\+.~#?&//={{ }}]+)+((\/)[\w#]+)*(\/\w+\?[[-a-zA-Z0-9@:%_\+.~#?&//={{ }}]]+=\w+(&[[-a-zA-Z0-9@:%_\+.~#?&//={{ }}]]+=\w+)*)?\/?$/gm);
}
